import { useAppSelector } from 'store/useAppSelector';

import {
  selectIsTFADialogOpened,
  selectIsTFAEnabled,
  selectIsTFAEndpointRefetching,
  selectIsTFAStatusLoaded,
  selectTFAError,
  selectTOTP,
} from '../store/selectors';
import {
  selectTFAStatus,
  selectTFAStatusLoading,
} from '../actions/fetchTFAStatus';

export const useTFA = () => {
  const isTFADialogOpened = useAppSelector(selectIsTFADialogOpened);
  const isTFAEnabled = useAppSelector(selectIsTFAEnabled);
  const isTFAEndpointRefetching = useAppSelector(selectIsTFAEndpointRefetching);
  const tfaError = useAppSelector(selectTFAError);
  const tfaStatus = useAppSelector(selectTFAStatus);
  const tfaStatusLoaded = useAppSelector(selectIsTFAStatusLoaded);
  const tfaStatusLoading = useAppSelector(selectTFAStatusLoading);
  const totp = useAppSelector(selectTOTP);

  return {
    isTFADialogOpened,
    isTFAEnabled,
    isTFAEndpointRefetching,
    tfaError,
    tfaStatus,
    tfaStatusLoaded,
    tfaStatusLoading,
    totp,
  };
};
